import { render } from "./BpmnGenerator.vue?vue&type=template&id=1c872f31&scoped=true"
import script from "./BpmnGenerator.vue?vue&type=script&lang=js"
export * from "./BpmnGenerator.vue?vue&type=script&lang=js"

import "./BpmnGenerator.vue?vue&type=style&index=0&id=1c872f31&lang=css"
import "./BpmnGenerator.vue?vue&type=style&index=1&id=1c872f31&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c872f31"]])

export default __exports__